// src/utils/auth.js

// Token 存储键名
const TOKEN_KEY = 'userToken';

/**
 * 设置 Token
 * @param {string} token - 后端返回的 Token 字符串
 */
export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

/**
 * 获取 Token
 * @returns {string|null} - 存储的 Token 或 null
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null;
}

/**
 * 清除 Token
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * 判断是否已登录（简单判断 Token 是否存在）
 * @returns {boolean}
 */
export function isLogin() {
  return !!getToken();
}